export const terms = {
  lastUpdated: 'January 25, 2026',
  lastUpdatedLabel: 'Last Updated',
  
  meta: {
    title: 'Terms and Conditions',
    description: 'Terms and Conditions for the use of the Termin Teiler platform'
  },
  
  nav: {
    title: 'Table of Contents',
    scope: 'Scope',
    subject: 'Subject of Offer',
    noContract: 'No Contractual Relationship',
    platformUse: 'Use of Platform',
    userObligations: 'User Obligations',
    liability: 'Liability',
    availability: 'Availability',
    termination: 'Termination',
    dataProtection: 'Data Protection',
    finalProvisions: 'Final Provisions',
  },
  
  sections: {
    scope: {
      title: '1. Scope',
      content: `
        <p>(1) These General Terms and Conditions apply to the use of the online platform Termin Teiler, operated by:</p>
        <p><strong>Feryal Catoglu<br/>
        TerminTeiler-Startpunkt57<br/>
        Sandstraße 26<br/>
        57072 Siegen<br/>
        Germany</strong></p>
        <p><strong>Email:</strong> <a href="mailto:support@terminteiler.com">support@terminteiler.com</a></p>
        <p>(2) The Terms and Conditions apply to all users of the platform in the current testing and MVP phase.</p>
      `
    },
    
    subject: {
      title: '2. Subject of Offer',
      content: `
        <p>(1) TerminTeiler provides a digital platform through which users can voluntarily share information about available or unused doctor appointments.</p>
        <p>(2) TerminTeiler:</p>
        <ul>
          <li>does not mediate medical services,</li>
          <li>does not provide medical advice,</li>
          <li>does not guarantee appointment availability,</li>
          <li>has no contractual relationship with medical practices or medical facilities.</li>
        </ul>
        <p>(3) The platform serves exclusively for technical testing, further development, and user feedback.</p>
      `
    },
    
    noContract: {
      title: '3. No Contractual Relationship with Third Parties',
      content: `
        <p>(1) The use of the platform does not establish a contractual relationship between TerminTeiler and doctors, medical facilities, or other third parties.</p>
        <p>(2) Any appointment arrangements are made independently and outside the responsibility of Termin Teiler.</p>
      `
    },
    
    platformUse: {
      title: '4. Use of Platform',
      content: `
        <p>(1) The use of the platform is voluntary and currently free of charge.</p>
        <p>(2) There is no claim to specific functions, content, or permanent availability.</p>
        <p>(3) TerminTeiler reserves the right to change, restrict, or discontinue functions at any time.</p>
      `
    },
    
    userObligations: {
      title: '5. User Obligations',
      content: `
        <p>Users commit in particular to:</p>
        <ul>
          <li>not posting illegal, misleading, or offensive content,</li>
          <li>not publishing personal data of third parties without their consent,</li>
          <li>not disseminating medical recommendations or diagnoses,</li>
          <li>not using the platform abusively.</li>
        </ul>
      `
    },
    
    liability: {
      title: '6. Liability',
      content: `
        <p>(1) Termin Teiler is liable without limitation in case of:</p>
        <ul>
          <li>intent</li>
          <li>gross negligence</li>
          <li>injury to life, body, or health</li>
        </ul>
        <p>(2) In case of slight negligence in the breach of essential contractual obligations, liability is limited to the foreseeable, typically occurring damage.</p>
        <p>(3) Liability for:</p>
        <ul>
          <li>missed or failed appointments,</li>
          <li>health or economic consequential damages,</li>
          <li>user content</li>
        </ul>
        <p>is excluded to the extent legally permissible.</p>
      `
    },
    
    availability: {
      title: '7. Availability',
      content: `
        <p>(1) TerminTeiler does not guarantee permanent availability of the platform.</p>
        <p>(2) Maintenance, technical disruptions, or further developments may lead to temporary restrictions.</p>
      `
    },
    
    termination: {
      title: '8. Termination of Use',
      content: `
        <p>(1) Users can discontinue use at any time.</p>
        <p>(2) TerminTeiler is entitled to exclude users from use in whole or in part in case of violations of these Terms and Conditions.</p>
      `
    },
    
    dataProtection: {
      title: '9. Data Protection',
      content: `
        <p>The processing of personal data is carried out in accordance with the <a href="/privacy-policy">Privacy Policy</a> of Termin Teiler, which is part of these Terms and Conditions.</p>
      `
    },
    
    finalProvisions: {
      title: '10. Final Provisions',
      content: `
        <p>(1) The law of the Federal Republic of Germany applies.</p>
        <p>(2) If users are merchants, the place of jurisdiction is Siegen.</p>
        <p>(3) Should individual provisions of these Terms and Conditions be invalid, the validity of the remaining provisions remains unaffected.</p>
      `
    }
  }
};
